var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-auto-transition',{attrs:{"type":"iv-fade-slide","step":_vm.step()}},[_c(_vm.$theme,{key:_vm.$theme.name,tag:"element"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }